import React from 'react'

import BodyLoader from '@shared/components/BodyLoader'
import PlatformSessionStore from '@shared/services/session/stores/platform-session-store'
import RealtimeAlert from '@shared/components/RealtimeAlert'
import Emitter from '@shared/services/main/events'
import EVENT_NAMES from '@shared/lib/constants/events'
import { LocalStorage } from '@shared/services/main/storage'

import AlertsLoad from '@shared/components/base/alert/AlertsLoad'
import InfoLoad from '@features/sportsbook-main/InfoLoad'

import UserSessionStore from '@features/auth/stores/user-session-store'
import UserLoad from '@features/sportsbook-main/UserLoad'

import { default as PlatformSessionLoad } from '@shared/services/session/parts/SessionLoad'
import { default as PlatformCsrfLoad } from '@shared/services/session/parts/CsrfLoad'
import { default as PlatformPrepaidSessionLoad } from '@shared/services/session/parts/prepaid/SessionLoad'

import AppRoutes from 'app/AppRoutes'

export default function SportsbookModule() {
  React.useEffect(() => {
    const handler = () => {
      const user = LocalStorage.get('user') || null
      if (user) {
        Emitter.emit(EVENT_NAMES.AUTH.LOGIN_SUCCESS_AFTER, { data: { user } })
      } else {
        Emitter.emit(EVENT_NAMES.AUTH.LOGOUT_SUCCESS_AFTER, {})
      }
    }
    window.addEventListener('c7:auth:changed', handler)
    return () => window.removeEventListener('c7:auth:changed', handler)
  }, [])

  return (
    <>
      <RealtimeAlert />
      <BodyLoader />
      <PlatformSessionStore>
        <UserSessionStore>
          <AlertsLoad />
          <PlatformCsrfLoad />
          <PlatformSessionLoad />
          <PlatformPrepaidSessionLoad />
          <InfoLoad />
          <UserLoad />
          <AppRoutes />
        </UserSessionStore>
      </PlatformSessionStore>
    </>
  )
}

